import React from 'react'
import ReactDOM from 'react-dom'
import { createStore, combineReducers } from 'redux'
import { configure } from '../api'
import { SearchPage } from '../pages'
import { Provider } from 'react-redux'
import { IntlProvider, addLocaleData } from 'react-intl'
import { numberOfTrips } from '../actions/search-actions'
import { selectedCurrency, setCurrency, pageLoader, itineraryPopupOpen, itineraryPopupData } from '../actions/main-actions'
import { currencyDirective } from '../directives'
import 'babel-polyfill'
import 'whatwg-fetch'
import { getLanguage } from '../utils'

import en from 'react-intl/locale-data/en.js'
import fr from 'react-intl/locale-data/fr.js'
import de from 'react-intl/locale-data/de.js'
import it from 'react-intl/locale-data/it.js'
import es from 'react-intl/locale-data/es.js'
import ErrorHandler from '../components/ErrorHandler'

if(process.env.SENTRY_KEY) {
  Sentry.init({
    dsn: process.env.SENTRY_KEY,
    ignoreErrors: ['AbortError', 'UnhandledRejection', 'Unexpected token o in JSON at position 1', 'Anonymous function(/gtm.js)'],
  })
}

addLocaleData([...en, ...fr, ...de, ...it, ...es])

let store = createStore(combineReducers({
  pageLoader,
  numberOfTrips,
  selectedCurrency,
  itineraryPopupOpen,
  itineraryPopupData,
}))

let language = getLanguage()
let messages = {}

window.store = store
configure(store)

// window.fx = fx

if(language !== 'en') {
  Promise.all([
    window.fetch(window.staticPath + `travel-app/dist/translations/travel-${language}.json`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/x-www-form-urlencoded',
      } }),
  ]).then(function([ response ]) {
    response.json().then((msg) => {
      messages = msg[`travel-${language}`]

      renderApp()
    })
  })
} else {
  renderApp()
}

function renderApp() {
  renderElement('search-la', SearchPage, {
    ...window.locationInfo,
    isWidget: window.isWidget,
    resortDetails: window.resortDetails,
    filters: window.filters,
    trustpilotLocale: window.trustpilotLocale })
  currencyDirective(function(currency) {
    store.dispatch(setCurrency(currency))
  })
}

function renderElement(id, ComponentToRender, props) {
  const element = document.getElementById(id)

  if(element) {
    ReactDOM.render(
      <IntlProvider locale={language === 'ach' ? 'en' : language} messages={messages}>
        <Provider store={store}>
          <ErrorHandler>
            <ComponentToRender {...props} />
          </ErrorHandler>
        </Provider>
      </IntlProvider>,
      element
    )
  }
}
